module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Dynamic Search with ajax")]), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('model-list-select', {
    attrs: {
      "list": _vm.countries,
      "option-value": "code",
      "option-text": "name",
      "placeholder": "select item"
    },
    on: {
      "searchchange": _vm.searchCountry
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('h4', [_vm._v("input text(searchText)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.searchText))]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedCountry.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedCountry.name))])])])])])]), _vm._v(" "), _c('h3', [_vm._v("Init with ajax")]), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('model-list-select', {
    attrs: {
      "list": _vm.animations,
      "option-value": "id",
      "custom-text": _vm.optionDisplayText,
      "placeholder": "select item"
    },
    on: {
      "searchchange": _vm.printSearchText
    },
    model: {
      value: (_vm.selectedAnimation),
      callback: function($$v) {
        _vm.selectedAnimation = $$v
      },
      expression: "selectedAnimation"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('h4', [_vm._v("input text(searchText)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.searchText2))]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedAnimation.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAnimation.title_short1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAnimation.twitter_account))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAnimation.public_url))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("id")]), _vm._v(" "), _c('th', [_vm._v("title_short1")]), _vm._v(" "), _c('th', [_vm._v("twitter_account")]), _vm._v(" "), _c('th', [_vm._v("public_url")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c97b974e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Model/ModelAjax.vue
// module id = 406
// module chunks = 2